/* eslint-disable no-debugger */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { CheckboxField, SubmitButton, TextField } from "../../components/formik";
import { updateQuestionAnswer } from "../../ducks/actions";
import { useActionRequest, useUserMe } from "../../hooks";

const EditQuestionAnswerDialog = ({ questionAnswer, onClose }) => {
  const intl = useIntl();
  const { user } = useUserMe();

  const updateQuestionAnswerRequest = useActionRequest({
    action: updateQuestionAnswer
  });

  const onEditQA = questionAnswer => {
    updateQuestionAnswerRequest({
      id: questionAnswer.id,
      questionAnswer: { ...questionAnswer, answerer_id: user.profile?.id }
    });
    onClose();
  };

  return (
    <Formik
      onSubmit={onEditQA}
      initialValues={{
        answer: "",
        question: "",
        published: false,
        ...questionAnswer
      }}
    >
      <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
        <DialogContent>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h5" noWrap>
              {intl.formatMessage({
                id: "Eposters.EditQuestionAnswerDialog.EditEPoster",
                defaultMessage: "Edit Question Answer"
              })}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <TextField
            name="question"
            label={intl.formatMessage({
              id: "Eposters.EditQuestionAnswerDialog.Question",
              defaultMessage: "Question"
            })}
            multiline
            rows={2}
            fullWidth
            disabled
          />
          <TextField
            name="answer"
            label={intl.formatMessage({
              id: "Eposters.EditQuestionAnswerDialog.Answer",
              defaultMessage: "Answer"
            })}
            multiline
            rows={2}
            fullWidth
          />
          <CheckboxField
            name="published"
            label={intl.formatMessage({
              id: "Eposters.EditQuestionAnswerDialog.Published",
              defaultMessage: "Published"
            })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            {intl.formatMessage({
              id: "Eposters.EditQuestionAnswerDialog.Close",
              defaultMessage: "Close"
            })}
          </Button>
          <SubmitButton onClick={onClose} variant="contained" color="primary" size="small">
            {intl.formatMessage({
              id: "Eposters.EditQuestionAnswerDialog.Save",
              defaultMessage: "Save"
            })}
          </SubmitButton>
        </DialogActions>
      </Dialog>
    </Formik>
  );
};

export default EditQuestionAnswerDialog;
